import styles from './M_TreeHeader.module.css';
import A_CircleButton from '@/components/A_Atoms/A_CircleButton/A_CircleButton';
import { getTranslation } from '@/constants/translations';
import { useLanguage } from '@/contexts/LanguageContext';
import { Q_Icon } from '@/components/Q_Quarks/Q_Icon/Q_Icon';
import { PATHS } from '@/constants/paths';

export default function M_TreeHeader() {
  const { language } = useLanguage();
  const t = (key: string) => getTranslation(language, key);

  return (
    <header className={styles.wrapper}>
      <A_CircleButton
        icon={
          <Q_Icon.ArrowLeftIcon
            width={14}
            height={27}
            stroke='currentColor'
            fill='none'
          />
        }
        onClick={() => {
          window.location.href = PATHS.HOME;
        }}
        variant='secondary'
      />
      <h2 className={styles.title}>{t('pages.tree.selectTree')}</h2>
    </header>
  );
}
